<template>
  <div class="maskBox">
    <div class="overSuccessful" :style="{backgroundImage:'url('+require('../../assets/images/cashWheel/OverSuccessfulUserBoxBg.png')+')'}">
      <div class="oneSpinChance">{{$t('lang.cashWheel.oneSpinChance')}}</div>
      <div class="goTryYourLuck">{{$t('lang.cashWheel.goTryYourLuck')}}</div>
      <img class="OverSuccessfulUserList" src="../../assets/images/cashWheel/OverSuccessfulUserList.png" alt="">
      <div class="overSuccessfulTip">{{$t('lang.cashWheel.overSuccessful')}}</div>
      <div class="btn" @click="close()">Go</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-overSuccessful',
  methods: {
    close () {
      this.$emit('closeModalOverSuccessful')
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes expandInOut {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.overSuccessful{
  background-size: 100% 100%;
  width: 93.33vw;
  height: 100.55vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5vw;
  animation: expandInOut 0.2s ease-out forwards;
  .oneSpinChance{
    color: #fff;
    font-size: 6.38vw;
    font-weight: 700;
  }
  .goTryYourLuck{
    color: #C9C9C9;
    font-size: 4.44vw;
  }
  .OverSuccessfulUserList{
    width: 68.4vw;
    height: 28.07vw;
  }
  .overSuccessfulTip{
    color: #fff;
    font-size: 4.44vw;
    font-weight: 700;
    width: 57.72vw;
    text-align: center;
    letter-spacing: 0.4vw;
  }
  .btn{
    width: 81.913vw;
    height: 10.833vw;
    background-color: #FFD84D;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2.22vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modal-overSuccessful.vue